<template>
    <input @input="handleChange" :value="value" type="text"/>
</template>

<script>
    import flatpickr from 'flatpickr'

    export default {
        props: ['value'],
        template: ``,
        mounted() {
            flatpickr(this.$el)
        },
        methods: {
            handleChange(e) {
                this.$emit('input', e.target.value);
            }
        }
    }
</script>
